<template>
    <div class="po-box" v-if="data_parse.purchaseLimit !== 0" :style="boxSize" >
        <div class="po-cont" :style="dynamicSize" >
            <img :src="data_parse.art + data_parse.config.background[_i18n.locale]" />
            <div class="products" v-for="(prod, i) in data_parse.products" :key="i" >
                <div class="item v-m" v-if="prod.items.coins && data_parse.config.products[i] && data_parse.config.products[i].coins" :style="itemStyle(data_parse.config.products[i].coins)" >
                    <img class="icon v-m" :src="data_parse.art + data_parse.config.products[i].coins.icon" :style="iconStyle(data_parse.config.products[i].coins)" />
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].coins)" >{{ fc(prod.items.coins, 1) }}</span>
                </div>
                <div class="item v-m" v-if="prod.items.chips && data_parse.config.products[i] && data_parse.config.products[i].chips" :style="itemStyle(data_parse.config.products[i].chips)" >
                    <img class="icon v-m" :src="data_parse.art + data_parse.config.products[i].chips.icon" :style="iconStyle(data_parse.config.products[i].chips)" />
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].chips)" >{{ fc(prod.items.chips, 2) }}</span>
                </div>
                <!--div class="item v-m" v-if="prod.items.loyalty && data_parse.config.products[i] && data_parse.config.products[i].loyalty" :style="itemStyle(data_parse.config.products[i].loyalty)" >
                    <img class="icon v-m" :src="data_parse.art + data_parse.config.products[i].loyalty.icon" :style="iconStyle(data_parse.config.products[i].loyalty)" />
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].loyalty)" >{{ prod.items.loyalty }}</span>
                </div-->
                <!--div class="item v-m" v-if="prod.bp && data_parse.config.products[i] && data_parse.config.products[i].loyalty" :style="itemStyle(data_parse.config.products[i].loyalty)" >
                    <img class="icon v-m" :src="data_parse.art + data_parse.config.products[i].loyalty.icon" :style="bpIconStyle(data_parse.config.products[i].loyalty)" />
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].loyalty)" >+{{ prod.bp }}</span>
                </div-->
                <div class="item v-m" v-if="prod.bp && data_parse.config.products[i] && data_parse.config.products[i].bp" :style="itemStyle(data_parse.config.products[i].bp)" >
                    <img class="icon v-m" :src="data_parse.art + data_parse.config.products[i].bp.icon" :style="bpIconStyle(data_parse.config.products[i].bp)" />
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].bp)" >+{{ prod.bp }}</span>
                </div>
                <div class="item btn v-m t-c" v-if="data_parse.config.products[i] && data_parse.config.products[i].btn" :style="btnStyle(data_parse.config.products[i].btn)" @click="buy(prod, prod.hash, prod.currency, prod.price)" >
                    <span class="beba v-m" :style="textStyle(data_parse.config.products[i].btn)" >{{ prod.isFree ? $t("message.free"): ` R$ ${prod.price}` }}</span>
                </div>
                <div class="item v-m" v-if="prod.isLocked && data_parse.config.products[i] && data_parse.config.products[i].btn" :style="itemStyle(data_parse.config.products[i].btn)" >
                    <img :src="data_parse.art + data_parse.config.products[i].btn.lock" :style="iconStyle(data_parse.config.products[i].btn)" />
                </div>
                <div class="item v-m" v-if="data_parse.config.products[i] && data_parse.config.products[i].shadow && (prod.isLocked || prod.isPictureLocked || prod.purchased)" :style="itemStyle(data_parse.config.products[i].shadow)" >
                    <img :src="data_parse.art + data_parse.config.products[i].shadow.icon" :style="iconStyle(data_parse.config.products[i].shadow)" />
                </div>
                <div class="item v-m" v-if="data_parse.config.products[i] && data_parse.config.products[i].lock && (prod.isLocked && !prod.purchased)" :style="itemStyle(data_parse.config.products[i].lock)" >
                    <img :src="data_parse.art + data_parse.config.products[i].lock.icon" :style="iconStyle(data_parse.config.products[i].lock)" />
                </div>
                <div class="item v-m" v-if="prod.purchased && data_parse.config.products[i] && data_parse.config.products[i].tick" :style="itemStyle(data_parse.config.products[i].tick)" >
                    <img :src="data_parse.art + data_parse.config.products[i].tick.icon" :style="iconStyle(data_parse.config.products[i].tick)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Object,
        extra: Object
    },
    data() {
        return {
            scale: 1,
            data_parse: null,
            cooldown: 0
        }
    },
    created() {
        this.data.config && (this.scale = Math.min(Math.min(document.body.offsetWidth, 1024) / this.data.config.size.width, 1));
        this.data_parse = JSON.parse(JSON.stringify(this.data));
    },
    computed: {
        boxSize() { return `width: ${this.data.config.size.width * this.scale}px;height: ${this.data.config.size.height * this.scale}px;` },
        dynamicSize() { return `width: ${this.data.config.size.width}px;height: ${this.data.config.size.height}px;transform: scale(${this.scale});-webkit-transform: scale(${this.scale});` }
    },
    methods: {
        fc(currency, type) { return utils.fc(Math.round(currency * (1 + (type === 1 ? this.extra.coins: this.extra.chips)))) },
        itemStyle(conf) { return `left: ${conf.x}px;top: ${conf.y}px;`; },
        iconStyle(conf) { return `transform: scale(${conf.scale || 1});-webkit-transform: scale(${conf.scale || 1})` },
        bpIconStyle(conf) { return `width: 100%;` },
        textStyle(conf) {
            let s = conf.stroke, sc = conf.strokeColor;
            return `
                color: #${conf.textColor};
                text-shadow: 0 ${s}px #${sc}, 0 -${s}px #${sc}, ${s}px 0 #${sc}, -${s}px 0 #${sc}, ${s}px ${s}px #${sc}, ${s}px -${s}px #${sc}, -${s}px ${s}px #${sc}, -${s}px -${s}px #${sc};
                ${conf.size ? `font-size: ${conf.size}px;`: ''}
                ${conf.size ? `line-height: ${conf.size}px;`: ''}`;
        },
        btnStyle(conf) {
            return `left: ${conf.x}px;top: ${conf.y}px;width: ${conf.width}px;height: ${conf.height}px;line-height: ${conf.height}px;`;
        },
        show() { this.isShow = true,this.$refs.popup.show() },
        hide() { this.isShow = false,this.$refs.popup.hide() },
        buy(prod, hash, currency, price) {
            if (this.cooldown > 0) return;
            if (prod.isFree) {
                // 限制free多次领取
                this.cooldown = 3000;
            } else {
                // 防抖
                setTimeout(() => {
                    this.resetButton();
                }, this.cooldown);
            }
            if (prod.isLocked || prod.purchased) return;
            this.$emit('buy', { "hash": hash, "currency": currency, "price": price, "free": prod.isFree })
        },
        unlock() {
            this.resetButton();
            for (let i = 0; i < this.data_parse.products.length; i++) {
                if (!this.data_parse.products[i].isLocked && !this.data_parse.products[i].purchased) {
                    this.data_parse.products[i].purchased = true;

                    if (i === (this.data_parse.products.length - 1)) {
                        this.data_parse.purchaseLimit > 0 && this.data_parse.purchaseLimit--;
                        if (this.data_parse.purchaseLimit > 0 || this.data_parse.purchaseLimit === -1) this.resetPurchase();
                    } else if (this.data_parse.products[i + 1] && this.data_parse.products[i + 1].isLocked) {
                        this.data_parse.products[i + 1].isLocked = false;
                    }
                    break;
                }
            }
        },
        resetButton() {
            this.cooldown = 0;
        },
        resetPurchase() {
            for (let i = 0; i < this.data_parse.products.length; i++) {
                this.data_parse.products[i].isLocked = i > 0;
                this.data_parse.products[i].purchased = false;
            }
        }
    }
}
</script>

<style lang="scss" >
.po-box {
    overflow: hidden;

    .po-cont {
        position: relative;
        display: inline-block;
        transform-origin: 0 0;

        .products {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;

            .item {
                position: absolute;
                white-space: nowrap;

                span {
                    font-size: 34px;
                }
            }

            .btn {

                span {
                    font-size: 26px;
                }
            }
        }

        .close {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 15;
        }
    }
}

.mobile {

    .po-cont {

        .products {

            .item {

                span {
                    font-size: 2rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/DynamicPo.vue